import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Topbar from '../components/Topbar';
import { FaUserPlus, FaTimes } from 'react-icons/fa';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import AdminSidebar from '../components/AdminSidebar';

function AdminDashboard() {
  const navigate = useNavigate();
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);

  const [formData, setFormData] = useState({
    modulename: 'CreateUser',
    department: '',
    name: '',
    email: '',
    phone: '',
    password: ''
  });

  const departmentOptions = [
    { value: 'SAE', label: 'SAE' },
    { value: 'ACCOUNTS', label: 'ACCOUNTS' },
    { value: 'FINANCE', label: 'FINANCE' },
    
  ];

  const handleOpenCreateUserModal = () => {
    setShowCreateUserModal(true);
  };

  const handleCloseCreateUserModal = () => {
    setShowCreateUserModal(false);
    setFormData({
      modulename: 'CreateUser',
      department: '',
      name: '',
      email: '',
      phone: '',
      password: ''
    });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleCreateUser = async (event) => {
    event.preventDefault();
    
    const apiFormData = new FormData();
    for (const key in formData) {
      apiFormData.append(key, formData[key]);
    }
    apiFormData.append("modulename","CreateUser")

    try {
      const response = await fetch(`https://pwd.smartstylin.in/index.php`, {
        method: 'POST',
        body: apiFormData
      });

      const result = await response.json();

      if (result.code === 1 || result.status === "success" || result.success === true) { // Adjust based on your API's success response
        toast.success(result.message || 'User created successfully!');
        handleCloseCreateUserModal();
      } else {
        toast.error(result.message || 'Failed to create user.');
      }
    } catch (error) {
      console.error('Error creating user:', error);
      toast.error('An error occurred. Please try again.');
    }
  };
  
  useEffect(() => {
    if (typeof window !== 'undefined' && window.bootstrap) {
      // Bootstrap JS is loaded
    } else {
      console.warn('Bootstrap JS not loaded, modals might not work as expected without it.');
    }
  }, []);


  return (
    <>
      <Topbar />
     
      <div className="d-flex" style={{ minHeight: 'calc(100vh - 56px)' }}>
         <AdminSidebar/>
        <div className="flex-grow-1 p-3 p-md-4 bg-light">
          <header className="mb-4 d-flex justify-content-between align-items-center">
            <h1 className="h2">Admin Dashboard</h1>
          </header>
          
          <div className="row">
            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
              <div
                className="card h-100 text-center shadow-sm"
                onClick={handleOpenCreateUserModal}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleOpenCreateUserModal(); }}
                style={{ 
                  cursor: 'pointer', 
                  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out'
                }}
                 onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                 onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0px)'}
              >
                <div className="card-body d-flex flex-column justify-content-center align-items-center">
                  <div className="mb-3" style={{fontSize: '2.5rem', color: '#0d6efd'}}>
                    <FaUserPlus />
                  </div>
                  <h5 className="card-title h6">Create User</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={showCreateUserModal} onHide={handleCloseCreateUserModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Create New User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleCreateUser}>
            <Form.Group className="mb-3" controlId="formUserName">
              <Form.Label>Name</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Enter full name" 
                name="name" 
                value={formData.name}
                onChange={handleInputChange}
                required 
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formUserEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control 
                type="email" 
                placeholder="Enter email" 
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required 
              />
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="formUserPhone">
              <Form.Label>Phone</Form.Label>
              <Form.Control 
                type="tel" 
                placeholder="Enter phone number" 
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                required 
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formUserDepartment">
              <Form.Label>Department</Form.Label>
              <Form.Select 
                name="department"
                value={formData.department}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Department</option>
                {departmentOptions.map(option => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formUserPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control 
                type="password" 
                placeholder="Password" 
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                required 
              />
            </Form.Group>
            
            <Form.Control type="hidden" name="modulename" value={formData.modulename} />

            <Button variant="secondary" onClick={handleCloseCreateUserModal} className="me-2">
              Close
            </Button>
            <Button variant="primary" type="submit">
              Create User
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AdminDashboard;